import {Component, Input} from '@angular/core';
import {TruncatePipe} from "../index";

@Component({
  selector: 'tn-history',
  templateUrl: './tn-history.component.html',
  styleUrls: ['./tn-history.component.scss'],
})


export class TnHistoryComponent {
  @Input() historyData: any[];
  @Input() headers: any[];

  // truncate threshold, if the length of the host string is longer, truncation will occur
  // default is 40 characters
  truncateThreshold = 40;

  constructor(private truncatePipe: TruncatePipe) {
  }

  /**
   * transform string for display, truncate the string if it is longer than the threshold
   */
  getUri(uri: string): string {
    if (uri && uri.length > 0) {
      return this.truncatePipe.transform(uri, this.truncateThreshold);
    } else {
      return 'n/a';
    }
  }

  /**
   * prepare tooltip string for the associate truncated string
   */
  getToolTip(uri: string): string {
    if (uri && uri.length > 0) {
      return uri;
    } else {
      return '';
    }
  }

 
}


